export default __webpack_public_path__ + "static/media/docx-icon.4ca86f62.svg";